export const APP_SET_LANGUAGE = '[APP] set language';
export const APP_ACCESS_DATA = '[APP] fetched menu, permissions, appParams';
export const APP_MENU_STATE = '[APP] set menu state';
export const APP_REMOVE_STORE = '[APP] remove stored props';

export const ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
